"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _ComponentWrapper = _interopRequireDefault(require("../../../ComponentWrapper"));

var _Layout = require("../../../Layout");

var _SliderNavItem = _interopRequireDefault(require("../SliderNavItem"));

var _MenuSlider = require("../MenuSlider.style");

var MenuSliderContent = function MenuSliderContent(_ref) {
  var links = _ref.links,
      secondaryActions = _ref.secondaryActions,
      toggleNav = _ref.toggleNav,
      isLargeSlider = _ref.isLargeSlider,
      variation = _ref.variation,
      rest = _objectWithoutProperties(_ref, ["links", "secondaryActions", "toggleNav", "isLargeSlider", "variation"]);

  var _ref2 = (0, _emotionTheming.useTheme)(),
      globalNav = _ref2.globalNav;

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_MenuSlider.SliderNavWrap, null, /*#__PURE__*/_react.default.createElement(_Layout.Container, Object.assign({}, rest, {
    px: ['none', 'none', 'base']
  }), /*#__PURE__*/_react.default.createElement(_Layout.Grid, {
    columnWidth: [12]
  }, links.map(function (link) {
    return /*#__PURE__*/_react.default.createElement(_MenuSlider.SliderNavColumn, {
      key: link.label,
      width: [12, null, 6, 6, 3]
    }, /*#__PURE__*/_react.default.createElement(_SliderNavItem.default, Object.assign({
      link: link,
      isLargeNav: isLargeSlider,
      toggleNav: toggleNav
    }, rest, {
      variation: variation
    })));
  })))), secondaryActions.length > 0 && /*#__PURE__*/_react.default.createElement(_ComponentWrapper.default, {
    columnWidth: [12]
  }, /*#__PURE__*/_react.default.createElement(_MenuSlider.ActionsWrap, null, secondaryActions && secondaryActions.map(function (action) {
    return /*#__PURE__*/_react.default.createElement(_MenuSlider.SliderAction, Object.assign({
      key: action.label,
      variant: globalNav.sliderActionVariant,
      inverted: globalNav.sliderActionInverted,
      onClick: function onClick() {
        toggleNav();
      }
    }, action), action.label);
  }))));
};

MenuSliderContent.propTypes = {
  secondaryActions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    startIcon: _propTypes.default.string
  })),
  links: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    description: _propTypes.default.string,
    navItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string,
      url: _propTypes.default.string
    }))
  })),
  toggleNav: _propTypes.default.func.isRequired,
  isLargeSlider: _propTypes.default.bool,
  variation: _propTypes.default.oneOf(['mega', 'primary'])
};
MenuSliderContent.defaultProps = {
  secondaryActions: [],
  links: [],
  isLargeSlider: false,
  variation: 'mega'
};
var _default = MenuSliderContent;
exports.default = _default;